import { IConfig } from '@cian/config/shared';
import { ICookieOptions, setCookie } from '@cian/utils/lib/browser/cookie';
import { getCookie } from '../../../../../utils/cookie';
import { FUTURE_MAP_ONBOARDING_CONFIG_KEY, FUTURE_MAP_ONBOARDING_COOKIE_KEY } from '../../../../../constants/map';

export const getIsFutureMapOnboardingEnabled = (config: IConfig): boolean => {
  return config.get<boolean>(FUTURE_MAP_ONBOARDING_CONFIG_KEY) || false;
};

export function getFutureInfrastructureOnboardingCookie() {
  const cookie = getCookie(FUTURE_MAP_ONBOARDING_COOKIE_KEY);

  return Number(cookie) || 0;
}

export function setFutureInfrastructureOnboardingCookie(times: number) {
  const cookieConfig: ICookieOptions = { expires: 365 * 86400, secure: false };
  const isLocalhost = typeof window !== undefined && window.location.hostname.indexOf('localhost') > -1;

  if (isLocalhost) {
    cookieConfig.domain = 'localhost';
  }

  setCookie(FUTURE_MAP_ONBOARDING_COOKIE_KEY, `${times}`, cookieConfig);
}
